import {createSlice} from "@reduxjs/toolkit";

const initialVehicletypesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  vehicletypeForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const vehicletypesSlice = createSlice({
  name: "vehicletypes",
  initialState: initialVehicletypesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getVehicletypeById
    vehicletypeFetched: (state, action) => {
      state.actionsLoading = false;
      state.vehicletypeForEdit = action.payload.vehicletypeForEdit;
      state.error = null;
    },
    // findVehicletypes
    vehicletypesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createVehicletype
    vehicletypeCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.vehicletype);
    },
    // updateVehicletype
    vehicletypeUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.vehicletype.id) {
          return action.payload.vehicletype;
        }
        return entity;
      });
    },
    // deleteVehicletype
    vehicletypeDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteVehicletypes
    vehicletypesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // vehicletypesUpdateState
    vehicletypesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
